export default __webpack_public_path__ + "static/media/walmart.010b62b8.png";